import {useMemo, useState} from 'react';

function paginateTale(text, pageSize = 900) {
    const paragraphs = (text || '')
        .replace(/\r\n/g, '\n')
        .split(/\n{2,}/)
        .map(p => p.replace(/\s*\n\s*/g, ' ').trim())
        .filter(Boolean);
    if (!paragraphs.length) return [[]];

    const chunks = [];
    for (const p of paragraphs) {
        if (p.length <= pageSize * 1.2) {
            chunks.push(p);
            continue;
        }
        const sentences = p.match(/[^.!?…]+[.!?…]+[\s)"»]*|[^.!?…]+$/g) || [p];
        let current = '';
        for (const s of sentences) {
            if (current.length + s.length > pageSize && current) {
                chunks.push(current.trim());
                current = s;
            } else {
                current += s;
            }
        }
        if (current.trim()) chunks.push(current.trim());
    }

    const pages = [[]];
    let charsInPage = 0;
    for (const c of chunks) {
        const currentPage = pages[pages.length - 1];
        if (currentPage.length > 0 && charsInPage + c.length > pageSize) {
            pages.push([]);
            charsInPage = 0;
        }
        pages[pages.length - 1].push(c);
        charsInPage += c.length;
    }
    return pages;
}

export default function SkazkiTaleBookText({text, title, pageSize = 550}) {
    const pages = useMemo(() => paginateTale(text, pageSize), [text, pageSize]);
    const [pageIndex, setPageIndex] = useState(0);

    const clampedIndex = Math.min(pageIndex, pages.length - 1);
    const currentParagraphs = pages[clampedIndex] || [];
    const isFirstPage = clampedIndex === 0;

    const goTo = (i) => setPageIndex(i);

    return (
        <div className="flex flex-col gap-3 md:gap-4">
            <div
                className="sk-tale-page relative bg-white border border-[#F6F6F6] rounded-[12px] px-6 md:px-12 py-6 md:py-10 h-[360px] md:h-[440px] overflow-y-auto">
                {isFirstPage && (
                    <div className="text-center mb-5 md:mb-7">
                        <div className="sk-tale-chapter-label">Глава первая</div>
                        {title && (
                            <div className="sk-tale-title text-[20px] md:text-[26px] mt-2 md:mt-3">{title}</div>
                        )}
                        <div className={`sk-tale-separator ${title ? 'mt-2 md:mt-3' : 'mt-1'}`} aria-hidden>✦</div>
                    </div>
                )}
                {currentParagraphs.length === 0 ? (
                    <p className="sk-tale-paragraph">&nbsp;</p>
                ) : (
                    currentParagraphs.map((p, i) => (
                        <p key={i}
                           className={`sk-tale-paragraph ${isFirstPage && i === 0 ? 'sk-tale-paragraph--first' : ''}`}>
                            {p}
                        </p>
                    ))
                )}
            </div>

            {pages.length > 1 && (
                <div className="flex items-center justify-center gap-1.5 flex-wrap">
                    {pages.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => goTo(i)}
                            className={`sk-page-pill ${i === clampedIndex ? 'sk-page-pill--on' : ''}`}
                            aria-label={`Страница ${i + 1}`}
                            aria-current={i === clampedIndex ? 'page' : undefined}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
